import { zodResolver } from '@hookform/resolvers/zod';
import { Modal } from '@mantine/core';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

import { WosResearcherIdRequest } from '@/module/Dashboard/model/DashboardTypes';

import { Form, TextInputControl } from '@/core/components';

interface ResearcherIdAddFormProps {
  onClose: () => void;
  isSubmitting: boolean;

  onChange: (request: WosResearcherIdRequest) => void;
}

export const researcherIdAddSchema = z.object({
  researcherId: z.string().min(3),
});

type ResearcherIdAddSchema = z.infer<typeof researcherIdAddSchema>;

export function ResearcherIdAddForm(props: ResearcherIdAddFormProps) {
  const { onClose, isSubmitting, onChange } = props;
  const { t } = useTranslation();
  const { control, handleSubmit } = useForm<ResearcherIdAddSchema>({
    defaultValues: { researcherId: '' },
    resolver: zodResolver(researcherIdAddSchema),
  });

  return (
    <Modal
      opened
      onClose={onClose}
      title={t('wos.addResearcherId')}
    >
      <Form
        onSubmit={handleSubmit(onChange)}
        onCancel={onClose}
        title=""
        isSubmitting={isSubmitting}
      >
        <TextInputControl
          label={t('wos.form.researcherId')}
          name="researcherId"
          description={t('wos.form.researcherId')}
          control={control}
          isSubmitting={isSubmitting}
        />
      </Form>
    </Modal>
  );
}
